import { useState } from 'react';

export const ImageLightbox = ({ title, largeImage, smallImage }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href={largeImage}
      target='_blank'
      rel='noopener noreferrer'
      style={{
        display: 'block',
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '14px',
        width: '100%',
        height: '100%',
        textDecoration: 'none',
        cursor: 'pointer',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Image with zoom */}
      <img
        src={smallImage}
        alt={title}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center top',
          display: 'block',
          transform: hovered ? 'scale(1.09)' : 'scale(1)',
          transition: 'transform 0.65s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        }}
      />

      {/* Permanent bottom gradient so title is always slightly readable */}
      <div style={{
        position: 'absolute',
        bottom: 0, left: 0, right: 0,
        height: '50%',
        background: 'linear-gradient(to top, rgba(10,10,20,0.7) 0%, transparent 100%)',
        opacity: hovered ? 0 : 0.5,
        transition: 'opacity 0.4s ease',
        pointerEvents: 'none',
      }} />

      {/* Full hover overlay */}
      <div style={{
        position: 'absolute',
        inset: 0,
        background: 'rgba(10,10,20,0.6)',
        opacity: hovered ? 1 : 0,
        transition: 'opacity 0.4s ease',
        pointerEvents: 'none',
      }} />

      {/* Center expand button — bounces in */}
      <div style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}>
        <div style={{
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #5ca9fb, #6372ff)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transform: hovered ? 'scale(1)' : 'scale(0)',
          opacity: hovered ? 1 : 0,
          transition: 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.3s ease',
          boxShadow: '0 0 0 10px rgba(92,169,251,0.2)',
        }}>
          <i className='fa fa-expand' style={{
            color: '#fff', fontSize: '18px',
            display: 'inline', width: 'auto', height: 'auto',
            padding: 0, background: 'none', boxShadow: 'none',
            borderRadius: 0, margin: 0, lineHeight: 1, transition: 'none',
          }}></i>
        </div>
      </div>

      {/* Slide-up title bar */}
      <div style={{
        position: 'absolute',
        bottom: 0, left: 0, right: 0,
        padding: '36px 18px 16px',
        background: 'linear-gradient(to top, rgba(10,10,20,0.95) 0%, transparent 100%)',
        transform: hovered ? 'translateY(0)' : 'translateY(110%)',
        transition: 'transform 0.38s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        pointerEvents: 'none',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '3px', height: '16px',
            background: 'linear-gradient(to bottom, #5ca9fb, #6372ff)',
            borderRadius: '2px', flexShrink: 0,
          }} />
          <span style={{
            color: '#fff',
            fontSize: '13px',
            fontWeight: '700',
            fontFamily: 'Raleway, sans-serif',
            letterSpacing: '0.3px',
          }}>
            {title}
          </span>
        </div>
      </div>
    </a>
  );
};
